import { useFormContext } from 'react-hook-form';
import type { CatalogRequestFormValues } from '@/components/CatalogRequestStepper/config';
import CTNInput from '@ctn/ui/components/ctn-input';
import type { CTNDropdownOptionProps } from '@ctn/ui/types/ctn-dropdown';
import CTNDropdown from '@ctn/ui/components/ctn-dropdown';
import CTNInputNest from '@ctn/ui/components/ctn-input-nest';

type PersonalDataStepProps = {
	readonly title: string;
};

export type PhonePrefix = {
	code: string; // ISO-2, ej: 'ES'
	dial: string; // Ej: '+34'
	name: string; // Ej: 'España'
	flagSrc: string; // Ruta de la imagen de la bandera
};

export const PHONE_PREFIXES: PhonePrefix[] = [
	{ code: 'ES', dial: '+34', name: 'España', flagSrc: '/assets/flags/es.svg' },
	{ code: 'PT', dial: '+351', name: 'Portugal', flagSrc: '/assets/flags/pt.svg' },
	{ code: 'FR', dial: '+33', name: 'Francia', flagSrc: '/assets/flags/fr.svg' },
	{ code: 'IT', dial: '+39', name: 'Italia', flagSrc: '/assets/flags/it.svg' },
	{ code: 'DE', dial: '+49', name: 'Alemania', flagSrc: '/assets/flags/de.svg' },
	{ code: 'GB', dial: '+44', name: 'Reino Unido', flagSrc: '/assets/flags/gb.svg' },
];

const classNameComponent = 'c-cnm-catalog-stepper';

export const PersonalDataStep = ({ title }: PersonalDataStepProps) => {
	const {
		control,
		formState,
		register,
		formState: { errors },
	} = useFormContext<CatalogRequestFormValues>();

	const prefixOptions: CTNDropdownOptionProps[] = PHONE_PREFIXES.map((p) => ({
		label: `${p.name} (${p.dial})`,
		value: p.dial,
	}));

	return (
		<div className={`${classNameComponent}__step`}>
			<h3 className={`${classNameComponent}__step-title`}>{title}</h3>

			<div className="[ o-grid ] [ u-mt-16 ]">
				<div className="o-grid__row">
					<div className="o-grid__col-12">
						<CTNInput
							type="text"
							control={control}
							name="name"
							label="Nombre completo o Razón social *"
							classNameField={`${classNameComponent}__form-field`}
							classNameInput={`${classNameComponent}__form-input`}
							placeholder="Su nombre o razón social"
							error={formState.errors.name?.message}
						/>
					</div>
				</div>
				<div className="o-grid__row">
					<div className="o-grid__col-12 o-grid__col-5@portrait o-grid__col-4@landscape">
						<CTNInput
							type="text"
							control={control}
							name="nif"
							label="NIF *"
							classNameField={`${classNameComponent}__form-field`}
							classNameInput={`${classNameComponent}__form-input`}
							placeholder="00000000X"
							error={formState.errors.nif?.message}
						/>
					</div>

					<div className="o-grid__col-12 o-grid__col-7@portrait o-grid__col-8@landscape">
						<CTNInput
							type="text"
							control={control}
							name="email"
							label="Email *"
							classNameField={`${classNameComponent}__form-field`}
							classNameInput={`${classNameComponent}__form-input`}
							placeholder="email_personal@gmail.com"
							error={formState.errors.email?.message}
						/>
					</div>
				</div>
				<div className="o-grid__row">
					<div className="o-grid__col-12 o-grid__col-5@portrait o-grid__col-5@landscape">
						<CTNInputNest
							label="Teléfono Móvil"
							widthLeft="120"
							classNameField={`${classNameComponent}__form-field`}
							error={errors.movil?.country?.message ?? errors.movil?.number?.message}
						>
							<CTNDropdown<CatalogRequestFormValues>
								required
								control={control}
								name="movil.country"
								options={prefixOptions}
								placeholder="+34"
								noFeedBack={false}
							/>
							<CTNInput<CatalogRequestFormValues>
								noField
								type="text"
								control={control}
								name="movil.number"
								maxLength={9}
								placeholder="Introduce tu número (solo dígitos)"
								error={errors.movil?.number?.message}
								classNameField={`${classNameComponent}__form-field`}
								classNameInput={`${classNameComponent}__form-input`}
							/>
						</CTNInputNest>
					</div>
				</div>
			</div>
		</div>
	);
};
